export const defaultObj = {
  clinicalRecord: {
    title: "Clinical Records",
    slug: "clinical_record",
    toggle: true,
    data: [
      {
        title: "Patient Information & Insurances",
        slug: "patient_sheet",
        days: "all",
        checked: false,
      },
      {
        title: "Medications",
        slug: "medications",
        days: "all",
        checked: false,
      },
      { title: "Goals", slug: "goals", days: "all", checked: false },
      {
        title: "Guidelines",
        slug: "guidelines",
        days: "all",
        checked: false,
      },
      {
        title: "Trackers",
        slug: "trackers",
        days: "all",
        checked: false,
        showRadioButton: true,
        range: "all",
        start_date: "",
        end_date: "",
      },
      {
        title: "Psycho social",
        slug: "psycho_social",
        days: "all",
        checked: false,
        showRadioButton: true,
        range: "all",
        start_date: "",
        end_date: "",
      },
      { title: "Events", slug: "events", days: "all", checked: false },
      { title: "Problems", slug: "problems", days: "all", checked: false },
      { title: "Allergy", slug: "allergy", days: "all", checked: false },
      {
        title: "Radiology",
        slug: "radiology",
        days: "all",
        checked: false,
        showRadioButton: true,
        range: "all",
        start_date: "",
        end_date: "",
      },
      {
        title: "Education",
        slug: "education",
        days: "all",
        checked: false,
      },
      { title: "Contact", slug: "contact", days: "all", checked: false },
      { title: "Barriers", slug: "barriers", days: "all", checked: false },
      {
        title: "Interventions",
        slug: "interventions",
        days: "all",
        checked: false,
      },
      {
        title: "Immunization",
        slug: "immunization",
        days: "all",
        checked: false,
        showRadioButton: true,
        range: "all",
        start_date: "",
        end_date: "",
      },
      {
        title: "Immunization Refusal",
        slug: "immunization_refusal",
        days: "all",
        checked: false,
        showRadioButton: true,
        range: "all",
        start_date: "",
        end_date: "",
      },
      {
        title: "Vitals",
        slug: "vitals",
        days: "all",
        checked: false,
        showRadioButton: true,
        range: "all",
        start_date: "",
        end_date: "",
      },
    ],
  },
  clinicalSummaryCCD: {
    title: "Clinical Summary CCD",
    slug: "ccd",
    toggle: false,
    showCheckBox: false,
    isChecked:false,
    selectedData: [],
    showAttachDialogState: true,
  },
  triageNotes: {
    title: "Triage Notes",
    slug: "triage",
    toggle: false,
    showCheckBox: false,
    isChecked:false,
    selectedData: [],
    showAttachDialogState: true,
  },
  screenings: {
    title: "Screenings",
    slug: "screening",
    toggle: false,
    showCheckBox: false,
    isChecked:false,
    selectedData: [],
    showAttachDialogState: true,
  },
  documents: {
    title: "Documents",
    slug: "documents",
    toggle: false,
    showCheckBox: false,
    isChecked:false,
    selectedData: [],
    listType: "all",
    showAttachDialogState: true,
  },
  labResults: {
    title: "Lab Results",
    slug: "labResults",
    toggle: false,
    showCheckBox: false,
    isChecked:false,
    selectedData: [],
    showAttachDialogState: true,
  },
  radiologyResults: {
    title: "Radiology Results",
    slug: "radiologyResults",
    toggle: false,
    showCheckBox: false,
    isChecked:false,
    selectedData: [],
    showAttachDialogState: true,
  },
  letterOrders: {
    title: "Letters / Orders",
    slug: "letterOrders",
    toggle: false,
    showCheckBox: false,
    isChecked:false,
    selectedData: [],
    listType: "all",
    showAttachDialogState: true,
  },
  encounter: {
    title: "Encounters",
    slug: "encounter",
    toggle: false,
    showCheckBox: false,
    isChecked:false,
    selectedData: [],
    listType: "all",
    showAttachDialogState: true,
  },
  billingData: {
    title: "Billing Data",
    slug: "billingData",
    toggle: false,
    showCheckBox: false,
    isChecked:false,
    selectedData: [],
    showAttachDialogState: true,
  },
  referrals: {
    title: "Referrals",
    slug: "referrals",
    toggle: false,
    showCheckBox: false,
    isChecked:false,
    selectedData: [],
    listType: "all",
    showAttachDialogState: true,
  },
  appointments: {
    title: "Appointments",
    slug: "appointments",
    toggle: false,
    showCheckBox: false,
    isChecked:false,
    selectedData: [],
    showAttachDialogState: true,
  },
  uploads: {
    title: "Uploads",
    slug: "uploads",
    toggle: false,
    showCheckBox: false,
    isChecked:false,
    selectedData: [],
    listType: "all",
    showAttachDialogState: true,

  },
};

export const calculateFileSize = (size) => {
  var unit, pw;
  size = Number(size);
  if (size >= 1000) {
    pw = 0;
    while (size >= 1000) {
      size = size / 1000;
      pw++;
    }
    switch (pw) {
      case 1:
        unit = "KB";
        break;
      case 2:
        unit = "MB";
        break;
      case 3:
        unit = "GB";
        break;
      default:
        unit = "TB";
    }
  } else {
    unit = "bytes";
  }
  return Math.round(size * 10) / 10 + " " + unit;
};
export const mergeArraysByKey = (
  primaryArray,
  secondaryArray,
  primaryKey = "id",
  secondaryKey = "id"
) => {
  return primaryArray?.map((item) => {
    const found = secondaryArray?.find(
      (replaceItem) => replaceItem[secondaryKey] === item[primaryKey]
    );
    return found ? found : item;
  });
};

export const toggleAttachDialogStateForLocationBase = (obj, newState) => {
  const updatedObj = { ...obj };
  Object.keys(updatedObj).forEach((key) => {
    if (updatedObj[key].hasOwnProperty("showAttachDialogState")) {
      updatedObj[key].showAttachDialogState = newState;
    }
    if (updatedObj[key].hasOwnProperty("showCheckBox")) {
      updatedObj[key].showCheckBox = !newState;
    }
  });
  delete updatedObj.uploads

  
  return updatedObj;
};